<template>
  <div class="main">
    <head-top />
    <div class="icon">
      <i class="el-icon-close" @click="colseDia()"></i>
    </div>
    <!-- 面包屑 -->
    <div class="container">
      <div class="nav">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>展商</el-breadcrumb-item>
          <!-- <el-breadcrumb-item >{{ exName }}</el-breadcrumb-item> -->
          <el-breadcrumb-item>{{ sizeForm.newsTitle }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="content">
        <div class="title">
          {{ sizeForm.newsTitle }}
        </div>

        <div v-if="sizeForm.createDate != ''" class="date">
          {{ sizeForm.createDate }}
        </div>
        <div v-else class="date">
          {{ dateTimeNow }}
        </div>

        <div class="strip">
          <div class="strip_blue"></div>
        </div>

        <div class="article">
          <div v-html="sizeForm.content"></div>
        </div>
        <div class="strip"></div>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import { baseFileUrl, forMat } from '../../../../utils/common.js';
import { addnews, getOneInfo, submitnews } from '../../../../api/newCenter.js';
import headTop from '../../common/viewHead.vue';
import Foot from '../../common/foot.vue';

export default {
  name: '',
  data() {
    return {
      baseFileUrl: baseFileUrl(),
      baseUrl: forMat(),
      sizeForm: {
        newsTitle: '', //标题
        abstracts: '', //摘要
        coverPhoto: '', //封面
        content: '', //内容
        language: 'zh_CN', //zh_CN  中英文切换
        createDate: '',
      },
      dateTimeNow: '',
    };
  },
  components: {
    headTop,
    Foot,
  },
  created() {
    const newsValue = JSON.parse(this.$store.getters.getNewsValue);
    this.dateTimeNow = newsValue.dateTimeNow;
    this.sizeForm = newsValue.sizeForm;
  },
  methods: {
    colseDia() {
      window.close();
    },
  },
};
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  position: relative;
  box-sizing: border-box;
  .icon {
    top: 100px;
    position: absolute;
    right: 35px;
    font-size: 25px;
    color: #333;
  }
  .foot[data-v-f73ab1d2] {
    height: 246px;
    background-image: url(/img/backImg.98b0a33a.png);
    background-position: center;
    width: 100%;
    padding-bottom: 50px;
    background-size: cover;
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
  }
  .container {
    width: 1270px;
    margin: 0 auto;
    //border: #b80059 1px solid;
    box-sizing: border-box;

    .nav{
      margin-top: 30px;
    }
    .content {
      //border: #fdd72a 1px solid;
      //height: 500px;
      width: 100%;
      margin-top: 70px;
      min-height: 377px;
      .title {
        font-size: 30px;
        text-align: center;
        //font-weight: 400;
        //box-sizing: border-box;
      }

      .date {
        color: #999999;
        font-size: 14px;
        text-align: center;
        margin: 19px 0 34px;
      }

      .strip {
        width: 100%;
        height: 4px;
        background: #e5f0f8;
        margin-bottom: 26px;
        //position: relative;
        .strip_blue {
          background: #006fb8;
          height: 100%;
          width: 245px;
        }
      }

      .article {
        width: 100%;
        line-height: 150%;
        margin-bottom: 47px;
        p {
          margin: 36px 0;
          font-size: 18px;
          color: #333333;
          text-indent: 2em;
        }

        img {
          width: 800px;
          height: 450px;
          display: block;
          margin: 10px auto 0;
        }

        .subtitle {
          font-size: 24px;
          margin: 18px 0;
          color: #333333;
        }
      }
    }

    .others {
      width: 100%;
      height: 120px;
      color: #666666;
      font-size: 16px;

      .go:hover {
        cursor: pointer;
        color: #006fb8;
      }
    }
  }
}
</style>
<style scoped>
.el-breadcrumb__item >>> .el-breadcrumb__inner {
  font-weight: 500;
}

.el-breadcrumb__item:last-child >>> .el-breadcrumb__inner {
  color: #006fb8;
  font-weight: 500;
}
</style>
